import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';

import { Profile } from '../../models/search.model';
import { WebApiModel } from '../../models/web-api.model';
import { RouterHelperService, RouteUrl } from '../../services/router-helper.service';
import { SettingsService } from '../../services/settings.service';
import { PopupMapComponent } from '../maps/popup-map/popup-map.component';

@Component({
  selector: 'hcf-search-result-detail',
  templateUrl: './search-result-detail.component.html',
  styleUrls: ['./search-result-detail.component.scss'],
  standalone: false,
})
export class SearchResultDetailComponent implements OnChanges {
  @Input() searchResult: Profile;
  @Input() typeFilter: string;
  @Input() places: WebApiModel.Location[];
  @Output() openPopupMap: EventEmitter<WebApiModel.Location[]> = new EventEmitter();

  filterType = { people: 'people', places: 'places' };
  placeLink: any[];
  profileCssClass: string = '';
  searchTypeCssClass: string = '';
  settings = SettingsService;

  @ViewChild('popupMapComponent') popupMapComponent: PopupMapComponent;

  ngOnChanges() {
    const id = this.searchResult.data.id;
    const route = this.getSearchResultName(this.searchResult.data, id);
    this.placeLink = route.link;
  }

  private getSearchResultName(detail: any, id: string): RouteUrl {
    let name = '';
    let routeType = '';
    this.searchTypeCssClass = detail.isAffiliatedProvider
      ? 'is-affiliated-provider'
      : detail.isEasyClaim
        ? 'is-easy-claim'
        : 'is-other';

    if (detail.practiceName) {
      name = detail.practiceName;
      routeType = RouterHelperService.routeType.placeProfile;
      this.profileCssClass = 'place-profile';
    } else if (detail.firstName) {
      name = detail.firstName + ' ' + detail.lastName;
      routeType = RouterHelperService.routeType.personProfile;
      this.profileCssClass = 'person-profile';
    }

    const route = RouterHelperService.getRoute(routeType, id, name, null);

    return route;
  }

  viewMapClicked() {
    let placesForMap: WebApiModel.Location[];
    if (this.searchResult.type === 'people') {
      placesForMap = this.getPersonLocationFromProfile(this.searchResult);
    } else {
      placesForMap = this.getPlaceLocationFromProfile(this.searchResult);
    }
    this.openPopupMap.emit(placesForMap);
  }

  getPlaceLocationFromProfile(profile: Profile): WebApiModel.Location[] {
    const place = <WebApiModel.Place>profile.data;
    const locationDetail = <WebApiModel.LocationDetail>{
      id: place.id,
      practiceName: place.practiceName,
      receptionLocation: place.receptionLocation,
      isAffiliatedProvider: place.isAffiliatedProvider,
      isEasyClaim: place.isEasyClaim,
      isConsultant: place.isConsultant,
      isTelehealth: place.isTelehealth,
    };
    const location = <WebApiModel.Location>{
      address: place.address,
      suburb: place.suburb,
      city: place.city,
      postcode: place.postcode,
      latitude: place.latitude,
      longitude: place.longitude,
      isAffiliatedProvider: place.isAffiliatedProvider,
      isEasyClaim: place.isEasyClaim,
      isTelehealth: place.isTelehealth,
      locationDetails: [locationDetail],
    };
    return [location];
  }

  getPersonLocationFromProfile(profile: Profile): WebApiModel.Location[] {
    const matchingLocations: WebApiModel.Location[] = [];
    this.places.forEach((location) => {
      if (location.locationDetails.findIndex((x) => x.personId === profile.data.id) > -1) {
        matchingLocations.push(location);
      }
    });
    return matchingLocations;
  }
}
